var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search-results"}},[(!_vm.package_rooms)?_c('loader'):_vm._e(),(_vm.package_rooms.length > 0)?_c('div',{staticClass:"search_results_body"},_vm._l((_vm.package_rooms),function(package_room){return _c('PackagesSearchRoom',{key:package_room.ID,attrs:{"result_data":package_room}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }